<script setup>
import {
  BUTTON_ICON_DENSITIES,
  BUTTON_SIZES_NEXT,
  BUTTON_VARIANTS
} from '@/utils/components-configurations/app-button'

import AppButtonNext from '@/components/ui/AppButtonNext/AppButtonNext'

defineOptions({
  name: 'ConfluenceMacroSettingsModalHeader'
})

const emit = defineEmits({
  close: null
})
</script>

<template>
  <div class="cms-Header">
    <AppButtonNext
      :icon-density="BUTTON_ICON_DENSITIES.FIT"
      :size="BUTTON_SIZES_NEXT.XS"
      :variant="BUTTON_VARIANTS.TERTIARY_GRAY"
      icon-before="close-next"
      @click="emit('close')"
    />
  </div>
</template>

<style lang="scss" scoped>
.cms-Header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 20px;
  width: 100%;
  align-self: flex-start;
  border-bottom: 1px solid $grey-2-next;
  position: sticky;
  z-index: 999999;
  top: 0;
  background: $white;
}
</style>
